import { render } from "./UpdateNotificationBanner.vue?vue&type=template&id=6b5a90ee&scoped=true"
import script from "./UpdateNotificationBanner.vue?vue&type=script&lang=js"
export * from "./UpdateNotificationBanner.vue?vue&type=script&lang=js"

import "./UpdateNotificationBanner.vue?vue&type=style&index=0&id=6b5a90ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5a90ee"]])

export default __exports__